import {
  Avatar,
  Badge,
  Card,
  Link,
  TextField,
  Typography,
} from '@mui/material';
import { TextareaAutosize } from '@mui/material';

import { Alert } from '../Alert';
import { Avatar as CustomAvatar } from '../Avatar';
import Button from '../Button';
import CreditCardInput from '../CreditCardInput';
import CustomInput from '../CustomInput';
import DatePicker from '../DatePicker';
import FileUploader from '../FileUploader';
import { FormHeader } from '../FormHeader';
import PasswordInput from '../PasswordInput';
import { PasswordVerify } from '../PasswordVerify';
import PhoneInput from '../PhoneInput';
import PhoneInputWithOTP from '../PhoneInputWithOTP';
import QuestionGroup from '../QuestionGroup';
import { Select } from '../Select';
import { SelectWithData } from '../SelectWithData';
import { Switch } from '../Switch';
import { Table } from '../Table';

export const formField = [
  {
    name: 'PhoneInputWithOTP',
    comp: PhoneInputWithOTP,
  },
  {
    name: 'TextField',
    comp: TextField,
  },
  {
    name: 'Typography',
    comp: Typography,
  },
  {
    name: 'Avatar',
    comp: Avatar,
  },
  {
    name: 'FormHeader',
    comp: FormHeader,
  },
  {
    name: 'PasswordVerify',
    comp: PasswordVerify,
  },
  {
    name: 'Select',
    comp: Select,
  },
  {
    name: 'DatePicker',
    comp: DatePicker,
  },
  {
    name: 'PhoneInput',
    comp: PhoneInput,
  },
  {
    name: 'PasswordInput',
    comp: PasswordInput,
  },
  {
    name: 'CustomInput',
    comp: CustomInput,
  },
  {
    name: 'CreditCardInput',
    comp: CreditCardInput,
  },
  {
    name: 'Switch',
    comp: Switch,
  },
  {
    name: 'SelectWithData',
    comp: SelectWithData,
  },
  {
    name: 'QuestionGroup',
    comp: QuestionGroup,
  },
  {
    name: 'FileUploader',
    comp: FileUploader,
  },
  {
    name: 'Link',
    comp: Link,
  },
  {
    name: 'Table',
    comp: Table,
  },
  {
    name: 'Card',
    comp: Card,
  },
  {
    name: 'Button',
    comp: Button,
  },
  {
    name: 'Alert',
    comp: Alert,
  },
  {
    name: 'Badge',
    comp: Badge,
  },
  {
    name: 'CustomAvatar',
    comp: CustomAvatar,
  },
  {
    name: 'TextArea',
    comp: TextareaAutosize,
  },
];
export default formField;
